module.exports = __webpack_public_path__ + "img/team-mosaic-02.95e7e12a.jpg";